module.exports = __webpack_public_path__ + "static/media/vision-educating-future.0cc419eb.png";